module.exports = __webpack_public_path__ + "static/img/shilla-ipark-thumb.136a51d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/shilla-ipark-thumb.jpg
// module id = juJS
// module chunks = 0